<template>
  <div v-if="!isFileUpload" class="wrap-group">
    <div
      v-for="(item, index) in formInputs"
      :key="`input-${index}`"
      :class="'row input-group ' + [item.margin]"
    >
      <div
        v-for="input in item.row"
        :key="input.id"
        :class="input.grid + ' inputs'"
      >
        <div
          :class="
            'wrap-input' + [input.type === 'textarea' ? ' textarea' : ''] + [input.name === 'job' ? ' job' : '']
          "
        >
          <input
            v-if="input.type !== 'textarea' && input.type !== 'select'"
            :id="'form' + input.name"
            :class="errors.has('form' + input.name.toString()) ? 'form-error' : ''"
            v-model="formData[input.name]"
            v-validate="input.validate"
            :type="input.type"
            :name="'form' + input.name"
          />

          <textarea
            v-else-if="input.type === 'textarea'"
            :id="'form' + input.name"
            :class="errors.has('form' + input.name.toString()) ? 'form-error' : ''"
            v-model="formData[input.name]"
            v-validate="input.validate"
            :name="'form' + input.name"
            :rows="input.rows"
          />

          <select
            v-else-if="input.type === 'select' && input.name !== 'job' && !input.multiple"
            :id="'form' + input.name"
            :class="errors.has('form' + input.name.toString()) ? 'form-error' : ''"
            v-model="formData[input.name]"
            v-validate="input.validate"
            :name="'form' + input.name"
          >
            <option
              v-for="option in input.options"
              :key="option.label"
              :value="option.value"
            >
              {{ option.label }}
            </option>
          </select>

          <select
            v-else-if="input.type === 'select' && input.name === 'job' && !input.multiple && input.options !== undefined"
            :id="'form' + input.name"
            :class="`select-${input.name} ${errors.has('form' + input.name.toString()) ? 'form-error' : ''}`"
            v-model="formData[input.name]"
            v-validate="input.validate"
            :name="'form' + input.name"
          >
            <option value="" selected disabled hidden>Selecione</option>
            <option
              v-for="category in input.options['category'] !== undefined ? Object.keys(input.options['category']) : []"
              :key="category"
              :value="category"
            >{{ input.options['category'][category] }}</option>
          </select>

          <select
            v-else-if="input.type === 'select' && input.name !== 'job' && input.multiple && formData[input.name] !== undefined"
            :id="'form' + input.name"
            :class="`multiple-select ${errors.has('form' + input.name.toString()) ? 'form-error' : ''}`"
            v-model="formData[input.name]"
            v-validate="input.validate"
            :name="'form' + input.name"
            multiple="multiple"
          >
            <option
              v-for="option in input.options"
              :key="option.label"
              :value="option.value"
            >
              {{ option.label }}
            </option>
          </select>

          <label
            v-if="input.type === 'select' && input.multiple && formData[input.name] !== undefined"
            :class="[formData[input.name].length > 0 ? 'not-empty' : '']"
            :for="'form' + input.name"
            >{{ input.placeholder.toString() }}</label
          >

          <label
            v-else
            :class="[formData[input.name] !== '' ? 'not-empty' : '']"
            :for="'form' + input.name"
            >{{ input.placeholder.toString() }}</label
          >

          <p
            v-if="errors"
            v-show="errors.has('form' + input.name.toString())"
            :class="`error-msg ${input.name === 'job' ? 'job' : ''}`"
          >
            {{ errors.first('form' + input.name.toString()) }}
          </p>
        </div>
      </div>
    </div>
  </div>

  <div v-else class="wrap-group">
    <div class="row files reset-row-files">
      <div
        v-for="image in formInputs"
        :id="'imagePhoto_' + image.id"
        :key="'imagePhoto_' + image.id"
        class="col-md-custom col-6 image"
      >
        <img
          v-if="filesData['photo_' + image.id] != ''"
          :src="filesData['photo_' + image.id]"
          :alt="image.name"
          class="img-fluid"
          @click="triggerElement('photo_' + image.id.toString(), 'click')"
        />

        <div v-else class="placeholder" @click="triggerElement('photo_' + image.id.toString(), 'click')">
          <img src="../assets/img/upload.png" alt="Upload" />
        </div>

        <label :for="'photo_' + image.id">
          {{ image.placeholder.toString() }}
        </label>

        <p
          v-if="errors"
          v-show="errors.has('photo_' + image.id.toString())"
          class="error-msg img"
        >
          {{ errors.first('photo_' + image.id.toString()) }}
        </p>
      </div>

      <input
        v-for="image in formInputs"
        :id="'photo_' + image.id"
        :key="image.id"
        v-validate="'required|image'"
        class="hide"
        type="file"
        :name="'photo_' + image.id"
        @change="processFile($event, 'photo_' + image.id.toString())"
      />
    </div>
  </div>
</template>

<script>
import { Validator } from 'vee-validate'
import SlimSelect from 'slim-select'

const dictionary = {
  pt: {
    messages: {
      alpha_spaces: _field =>
        'Este campo deve conter apenas caracteres alfabéticos',
      email: 'Este campo deve ser um endereço de email válido',
      date_format: 'Este campo deve estar no formato dd/MM/aaaa'
    }
  }
}

// Override and merge the dictionaries
Validator.localize(dictionary)

export default {
  inject: ['$validator'],

  props: {
    formInputs: {
      type: Array,
      required: true
    },
    formData: {
      type: Object,
      required: true
    },
    filesData: {
      type: Object,
      required: false
    },
    isFileUpload: {
      type: Boolean,
      required: true
    }
  },

  data () {
    return {
      errorPt: {
        custom: {}
      },
      errorEn: {
        custom: {}
      }
    }
  },

  mounted () {
    /**
     * Set dynamicaly the formData object
     */
    setTimeout(() => {
      this.isFileUpload
        ? this.formInputs.forEach(input => {
          this.$set(this.filesData, 'photo_' + input.id, '')

          this.$set(this.errorEn.custom, 'photo_' + input.id.toString(), {
            required: 'This field is required'
          })
          this.$set(this.errorPt.custom, 'photo_' + input.id.toString(), {
            required: 'Este campo é requerido'
          })
        })
        : this.formInputs.forEach(item => {
          item.row.forEach(input => {
            this.$set(this.formData, input.name, input.type === 'select' && input.multiple ? [] : '')
            this.$set(this.errorEn.custom, 'form' + input.name.toString(), {
              required: 'This field is required'
            })
            this.$set(this.errorPt.custom, 'form' + input.name.toString(), {
              required: 'Este campo é requerido'
            })
          })
        })
    }, 50)

    setTimeout(() => {
      Validator.localize('pt', this.errorPt)

      // eslint-disable-next-line no-new
      new SlimSelect({
        select: '.multiple-select',
        placeholder: ' ',
        searchText: 'Nenhum resultado encontrado',
        searchPlaceholder: 'Buscar'
      })
    }, 100)
  },

  methods: {
    processFile (e, data) {
      const files = e.target.files || e.dataTransfer.files

      if (!files.length) { return }

      this.filesData[data.toString()] = new Image()

      const reader = new FileReader()

      reader.onload = (e) => {
        this.filesData[data.toString()] = e.target.result
      }

      reader.readAsDataURL(files[0])
    },

    triggerElement (_elem, _action) {
      _elem = _elem.toString()
      _elem = document.getElementById(_elem)

      switch (_action) {
        case 'focus':
          _elem.focus()
          break

        case 'click':
          _elem.click()
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap-group {
  .input-group {
    margin-top: 20px;

    @media (max-width: 768px) {
      margin-top: 0;
    }

    .inputs {
      padding: 0;

      .wrap-input {
        width: 100%;
        position: relative;
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        justify-content: flex-start;
        align-items: flex-start;
        align-content: flex-start;

        &.job {
          flex-direction: row-reverse;
          align-content: center;
          justify-content: center;
          align-items: baseline;

          label {
            position: relative;
            font-size: 14px;
            font-weight: 300;
            transition: all .25s ease;
            color: white;
          }
        }

        input,
        select {
          width: 100%;
          margin-bottom: 20px;
          transition: all .25s ease;
          border: 1px solid;
          border-color: transparent;
          background: white;
          font-size: 14px;
          font-weight: 300;
          color: #884E79;
          text-align: left;
          height: 30px;

          @media (max-width: 768px) {
            margin-bottom: 40px;
          }

          &:focus,
          &:active,
          &:hover {
            border-color: white;
            outline: none;

            ~ label {
              left: 0;
              top: -22px;
              color: white;
            }
          }
        }

        .ss-main.multiple-select {
          &:hover {
            ~ label {
              left: 0;
              top: -22px;
              color: white;
            }
          }
        }

        select {
          option {
            color: #884E79;
            font-weight: 300;
          }

          &.select-job {
            max-width: 200px;

            &:focus,
            &:active,
            &:hover {
              border-color: white;
              outline: none;

              ~ label {
                left: unset;
                top: unset;
              }
            }
          }
        }

        textarea {
          width: 100%;
          margin-bottom: 35px;
          transition: all .25s ease;
          border: 1px solid;
          border-color: transparent;
          background: white;
          font-size: 14px;
          font-weight: 300;
          color: #884E79;
          text-align: left;

          &:focus,
          &:active,
          &:hover {
            border-color: white;
            outline: none;

            ~ label {
              left: 0;
              top: -22px;
              color: white;
            }
          }
        }

        label {
          position: absolute;
          left: 5px;
          top: 5px;
          // top: -22px;
          // right: 0;
          font-size: 14px;
          font-weight: 300;
          transition: all .25s ease;
          color: #884E79;
          // text-transform: capitalize;
        }

        label.not-empty {
          left: 0px;
          top: -22px;
          color: white;
        }

        label[for="formjob"]{
          left: unset;
          top: unset;
          margin-right: 10px;
          font-weight: 500;

          &::after {
            content: ':';
          }
        }
      }

      // .wrap-input.textarea {
      //   margin-top: 10px;
      // }
    }
  }

  // .selects {
  //   margin-top: 5px;

  //   .select {
  //     width: 100%;
  //     position: relative;
  //     display: flex;
  //     flex-direction: column;
  //     flex-wrap: wrap;
  //     justify-content: flex-start;
  //     align-items: flex-start;
  //     align-content: flex-start;
  //     padding: 0 5px;

  //     select {
  //       width: 100%;
  //       margin-bottom: 35px;
  //       transition: all .25s ease;
  //       border: 1px solid;
  //       border-color: transparent;
  //       background: white;
  //       font-size: 14px;
  //       font-weight: 300;
  //       color: #884E79;
  //       text-align: left;
  //       height: 30px;

  //       option {
  //         color: #884E79;
  //         font-weight: 300;
  //       }

  //       &:focus,
  //       &:active {
  //         border-color: white;
  //         outline: none;

  //         // ~ label {
  //         //   left: 0;
  //         //   top: -22px;
  //         // }
  //       }
  //     }

  //     label {
  //       position: absolute;
  //       top: -22px;
  //       left: 5px;
  //       // top: 5px;
  //       // right: 5px;
  //       font-size: 14px;
  //       font-weight: 300;
  //       transition: all .25s ease;
  //       color: white;
  //       text-transform: capitalize;
  //     }

  //     // label.not-empty {
  //     //   left: 0px;
  //     //   top: -22px;
  //     // }
  //   }
  // }

  .files {
    margin-bottom: 40px;

    @media (max-width: 768px) {
      margin-bottom: 30px;
    }

    .image {
      text-align: center;
      cursor: pointer;
      padding: 0 5px;

      @media (max-width: 768px) {
        margin-bottom: 10px;
      }

      // &:first-of-type {
      //   padding-left: 0;
      // }
      // &:last-of-type {
      //   padding-right: 0;
      // }

      &:hover {
        .placeholder {
          img {
            transform: scale(1.08, 1.08);
          }
        }
      }

      label {
        padding: 20px 0;
        font-size: 14px;
        font-weight: 300;
        color: #884E79;
        background: white;
        width: 100%;
        margin-bottom: 0;
      }

      // img {

      // }

      .placeholder {
        display: flex;
        justify-content: center;
        padding: 48%;
        background: #C4C4C4;
        width: 100%;

        img {
          transition: all .25s ease;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/InputGroup.vue